import {_, React, observer, observable, computed, IDisposer, action, useLocalStore, useEffect, useLayoutEffect, classNames, useAsObservableSource} from '@api'
import {useTldrawApp} from '@modules/whiteboard'
import {HighlighterShape} from '@modules/whiteboard/shapes/highlighter/Highlighter'
import {HighlighterComponentStore} from '@modules/whiteboard/shapes/highlighter/HighlighterComponent'
import {TLComponentProps} from '@tldraw/core'
import * as css from './Highlighter.css'

/// region Components

interface MyProps extends TLComponentProps<HighlighterShape> {
  className?: string
}

export const HighlighterIndicator = observer<MyProps, any>(function HighlighterIndicator({className, shape}, ref) {
  const {shapeComponentStores} = useTldrawApp(),
    {pointsPath} = shapeComponentStores[shape.id] as HighlighterComponentStore

  return <path d={pointsPath} className={css.indicator} fill="none" ref={ref}/>
}, {forwardRef: true})

/// endregion




// WEBPACK FOOTER //
// ./src/modules/whiteboard/shapes/highlighter/HighlighterIndicator.tsx